exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.staticcontent.accpage[data-v-75002ed8] {\n  text-align: center;\n}\n/*# sourceMappingURL=src/components/common/errors/p404.css.map */", "", {"version":3,"sources":["D:/Build/MM2/Releases/20.4/WEB/CTS/ROBO Client/src/components/common/errors/src/components/common/errors/p404.vue","D:/Build/MM2/Releases/20.4/WEB/CTS/ROBO Client/src/components/common/errors/p404.vue"],"names":[],"mappings":";AAmDA;EACE,mBAAA;CClDD;AACD,iEAAiE","file":"p404.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.staticcontent.accpage\n  text-align center\n",".staticcontent.accpage {\n  text-align: center;\n}\n/*# sourceMappingURL=src/components/common/errors/p404.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75002ed8","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/errors/p404.vue
// module id = cHGh
// module chunks = 1